import template from './hirek-reszletes.pug';
import moment from 'moment';
import 'angular-bind-html-compile';
import getUrlParams from '../../../common/getallurlparams/getallurlparams';
const MODULE_NAME = 'hirekReszletes';
class HirekReszletesController {
	constructor(hirekService, $rootScope, $document, $window) {
		'ngInject';
		this._hirekService = hirekService;
		this._$rootScope = $rootScope;
		this._$document = $document;
		this._$window = $window;
	}
	$onInit() {
		this._id = getUrlParams().id;
		this._getHir();
		this.shareUrl = encodeURIComponent(this._$document[0].URL);
	}
	_getHir() {
		this._hirekService.get(this._id).then((response) => {
			this.hir = angular.copy(response);
			this._$window.document.title += ' ' + this.hir.cim;
			this._$rootScope.$broadcast('hirekMorzsamenuChange', this.hir.cim);
			if (this.hir.cimkek) {
				this.hir.cimkek = this.hir.cimkek.split(', ');
			}
			this.hir.megjelenesDatuma = moment(this.hir.megjelenesDatuma).toDate();
		}, () => {
			this.technikaiHiba = true;
		});
	}
}

export default angular.module(MODULE_NAME, ['angular-bind-html-compile'])
	.component('hirekReszletes', {
		controller: HirekReszletesController,
		template: template(),
		bindings: {
			elosztoUrl: '@'
		}
	}).name;



// WEBPACK FOOTER //
// ./source/applications/hirek/hirek-reszletes/hirek-reszletes.js